var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8755 11.8479C45.1745 14.2831 43.0522 16.395 40.6087 18.0841C40.4541 22.3558 39.2072 26.5165 36.987 30.1691C34.7668 33.8217 31.6474 36.8443 27.9266 38.9483C24.2059 41.0523 20.0079 42.1675 15.7335 42.1874C11.4591 42.2073 7.25094 41.1312 3.51074 39.062L3.51201 39.0597C8.39608 38.992 13.1522 37.4881 17.1872 34.7354C12.8679 31.7914 9.57797 27.5698 7.77904 22.662C5.9801 17.7541 5.76217 12.4064 7.15579 7.36841C9.15182 10.4423 11.7993 13.0398 14.9109 14.9767C18.0224 16.9135 21.5219 18.1424 25.1612 18.5764C24.778 16.7494 25.0608 14.8458 25.9596 13.2097C26.8584 11.5736 28.3132 10.3133 30.0607 9.65691C31.8082 9.00052 33.7329 8.99137 35.4866 9.63114C37.2402 10.2709 38.7069 11.5173 39.6212 13.1448C42.09 13.0711 44.5343 12.6347 46.8755 11.8479Z",
    stroke: "#E5E5E5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.bdf4a3b8b8ba0dea54dfe45f2732e8a4.svg";
export { ForwardRef as ReactComponent };